import axios from 'axios';
import constants from '../constants';

const getAutoShipments = async (customerNumber: string) => {
  try {
    const response = await axios.get(`${constants.SUBSCRIPTION_SERVICE_URL}/api/Forecast/customer/${customerNumber}`);
    return response.data;
  } catch (error) {
    console.error(error);
    return [];
  }
};

const getSubscriptionItems = async (customerNumber: string) => {
  try {
    const response = await axios.get(`${constants.SUBSCRIPTION_SERVICE_URL}/api/tbr/customer/${customerNumber}`);
    return response.data;
  } catch (error) {
    console.error(error);
    return [];
  }
};

const getSubscriptionTbrItems = async () => {
  try {
    const response = await axios.get(`${constants.SUBSCRIPTION_SERVICE_URL}/api/RefillableItem`);
    return response.data;
  } catch (error) {
    console.error(error);
    return [];
  }
};

export { getAutoShipments, getSubscriptionItems, getSubscriptionTbrItems };
